import { GridCellProps } from '@progress/kendo-react-grid';
import { useMemo } from 'react';
import GridCellBase from 'src/components/GridCellBase';
import PopUpContentWrapper from 'src/components/PopUpContentWrapper';
import PopUp from 'src/components/design-system/PopUp';
import { getBgColorString, getIcon } from 'src/utils/icons';

const ErrorCell = (props: GridCellProps) => {
  const { dataItem } = props;

  const errorMessages: string[] = useMemo(() => dataItem.errors || [], [dataItem.errors]);

  const warningMessages: string[] = useMemo(() => dataItem.warnings || [], [dataItem.warnings]);

  const infos: string[] = useMemo(() => dataItem.infos || [], [dataItem.infos]);

  const bgColor = getBgColorString(errorMessages, warningMessages, infos);

  return (
    <GridCellBase
      {...props}
      disableToolTip
      className={`overflow-visible-imp  ${props.className}`}
      style={{ backgroundColor: bgColor }}
    >
      <PopUp
        popupAlign={{ horizontal: 'left', vertical: 'center' }}
        anchorAlign={{ horizontal: 'right', vertical: 'top' }}
        className="max-h-[180px]"
        content={
          <div className="m-1 max-w-[350px]">
            <PopUpContentWrapper type="Error" contents={errorMessages as string[]} />
            <PopUpContentWrapper type="Warning" contents={warningMessages as string[]} />
            <PopUpContentWrapper type="Information" contents={infos as string[]} />
          </div>
        }
      >
        <div className="flex justify-center items-center">
          {getIcon(errorMessages as string[], warningMessages as string[], infos as string[])}
        </div>
      </PopUp>
    </GridCellBase>
  );
};

export default ErrorCell;
